import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useCredentials } from '@/store/auth-store';

export function useAuthEventListener() {
  const navigate = useNavigate();
  const credentials = useCredentials();
  const location = useLocation();

  useEffect(() => {
    const handleSessionExpired = () => {
      navigate('/login', {
        replace: true,
        state: { from: location, userId: credentials.id },
      });
    };

    window.addEventListener('auth:sessionExpired', handleSessionExpired);

    return () => {
      window.removeEventListener('auth:sessionExpired', handleSessionExpired);
    };
  }, [navigate, location]);
}
